<template>
  <el-dialog append-to-body custom-class="moreCopyDialog" title="批量复制" :visible.sync="show" width="30%">
    <el-form ref="formRef" label-position="left" label-width="150px" :model="formVal">
      <el-form-item label="最大可复制箱子数" required prop="max">
        <el-input-number disabled :value="formVal.max" :controls="false"></el-input-number>
      </el-form-item>
      <el-form-item label="箱子数" prop="num" :rules="[{ required: true, message: '请输入箱子数', trigger: 'blur' }]">
        <el-input-number v-model="formVal.num" :controls="false" :min="1" :max="formVal.max"></el-input-number>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="ok">确认</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { boxCopyMaxAmount, boxBigBatchCopy, boxFbaBatchCopy } from "@/apis/outStock"
export default {
  data() {
    return { show: false, formVal: { num: null, max: 0 }, originData: {} }
  },
  components: {
  },
  props: {
    packingType: {
      type: String,
      default: '0'
    }
  },
  methods: {
    async showDialog(data) {
      this.originData = data;
      const { deliveryTaskCode, deliveryBoxCode } = data
      const res = await boxCopyMaxAmount({ deliveryTaskCode, deliveryBoxCode, packingType: this.packingType })
      if (res.code === 0 && res.data > 0) {
        this.formVal = { max: res.data };
        this.show = true
      } else {
        this.$message.error('已处于最大箱子数,不可以批量复制')
      }
    },
    cancel() {
      this.show = false
    },
    // 确定点击
    async ok() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          const { deliveryBoxCode, deliveryTaskCode, insidePackCode } = this.originData;
          const api = this.packingType === '0' ? boxBigBatchCopy : boxFbaBatchCopy;
          const res = await api({ copyBoxAmount: this.formVal.num, deliveryBoxCode, deliveryTaskCode, insidePackCode })
          if (res.code === 0) {
            this.packingType === '0' ? this.$bus.$emit("triggerRefresh") : this.$bus.$emit("triggerRefreshFBA");
            this.$message.success('复制成功')
            // this.$emit('ok', res.data)
          }
        }
      })
    }
  }
}
</script>

<style scoped>
:v-deep .tips {
  text-align: left;
}

.moreCopyDialog {
  z-index: 100;
}
</style>